import { render, staticRenderFns } from "./riskSection.vue?vue&type=template&id=1fd91ceb&scoped=true&"
import script from "./riskSection.vue?vue&type=script&lang=ts&"
export * from "./riskSection.vue?vue&type=script&lang=ts&"
import style0 from "./riskSection.vue?vue&type=style&index=0&id=1fd91ceb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd91ceb",
  null
  
)

export default component.exports